import React, { useEffect, useState } from "react";
import styles from "@/components/pages/text-to-music/styles/text-to-music-page.module.scss";
import StyledMultilineInput from "@/components/common/styled-multiline-input";
import { TextToMusicSettings } from "@/components/pages/text-to-music/components/providers/text-to-music-provider";
import { TextToSpeechSettings } from "@/components/pages/text-to-speech/components/providers/text-to-speech-provider";

type TextToAudioInputProps = {
  settings: TextToMusicSettings | TextToSpeechSettings;
  handleTextChange: (text: string) => void;
  placeholder: string;
  maxLength: number;
};

const TextToAudioInput = ({
  settings,
  handleTextChange,
  placeholder,
  maxLength,
}: TextToAudioInputProps) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(settings.text);
  }, [settings.text]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    handleTextChange(newValue);
  };

  return (
    <StyledMultilineInput
      overriddenClass={styles.input_field}
      onChange={handleChange}
      value={value}
      placeholder={placeholder}
      maxlength={maxLength}
    />
  );
};

export default TextToAudioInput;
